import videojs from "video.js";

import type Player from "video.js/dist/types/player";

/**
 * HACK: theoplayerの読み込みが完了する前にこのモジュールがインポートされると、
 * getVideoJsComponent内でwindow.THEOplayerがundefinedとなりエラーになるため、
 * 関数としてエクスポートし、必要なときに呼び出す形にする。
 * 本当はnpm管理のtheoplayerパッケージを使いたいが、検証が不十分なため現状はこの方法で対応。
 */
export const getIvsMobileController = () => {
  const VideoJSComponent = videojs.getComponent("Component");

  class MobileController extends VideoJSComponent {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    createEl() {
      const el = videojs.dom.createEl("div", {
        className: "vjs-custom-mobile-controller",
      });
      return el;
    }
  }

  return MobileController;
};

/**
 * HACK: theoplayerの読み込みが完了する前にこのモジュールがインポートされると、
 * getVideoJsComponent内でwindow.THEOplayerがundefinedとなりエラーになるため、
 * 関数としてエクスポートし、必要なときに呼び出す形にする。
 * 本当はnpm管理のtheoplayerパッケージを使いたいが、検証が不十分なため現状はこの方法で対応。
 */
export const getIvsMobileControllerPlayButton = () => {
  const VideoJSButton = videojs.getComponent("Button");

  class MobileControllerPlayButton extends VideoJSButton {
    handleUpdate: () => void;

    constructor(player: Player, options = {}) {
      super(player, options);
      this.handleUpdate = () => this.updateIcon();

      this.handleUpdate();

      player.on(["play", "pause"], this.handleUpdate);
    }

    dispose() {
      this.player().off(["play", "pause"], this.handleUpdate);
      super.dispose();
    }

    handleClick() {
      if (this.player().paused()) {
        void this.player().play();
      } else {
        this.player().pause();
      }
    }

    updateIcon() {
      const isPlaying = !this.player().paused();
      this.el().innerHTML = isPlaying
        ? `
        <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 21.5067H6.0067V0.493305H0V21.5067ZM11.9933 0.493305V21.5067H18V0.493305H11.9933Z" fill="white"/>
        </svg>
      `
        : `
        <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M-0.00683594 0.49332V21.5067L16.5066 11L-0.00683594 0.49332Z" fill="white"/>
        </svg>
      `;
    }

    createEl() {
      const el = videojs.dom.createEl("div", {
        className:
          "vjs-custom-mobile-controller-button vjs-custom-mobile-controller-play",
      });
      return el;
    }
  }

  return MobileControllerPlayButton;
};
